import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { Export } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ExportFormatEnum, PdfPaperSize } from 'components/ExportModal/Types'

interface Data {
  export: Export
}

export interface Variables {
  almanacFileId: string
  exportFormat: ExportFormatEnum.Pdf | ExportFormatEnum.DesignMedia | ExportFormatEnum.Html
  pageFormat?: PdfPaperSize
  signal?: AbortSignal
}

export const createExport = async ({
  exportFormat,
  pageFormat,
  almanacFileId,
  signal,
}: Variables & { workspaceId: number }) => {
  const res = await sendToApi<Data>(`/almanac_files/${almanacFileId}/exports`, {
    method: 'POST',
    body: {
      export_format: exportFormat,
      page_format: pageFormat,
    },
    signal,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export interface Options<Context = unknown>
  extends Omit<UseMutationOptions<Export, Error, Variables, Context>, 'mutationFn'> {}

export const useCreateExport = (options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<Export, Error, Variables>(async (vars) => {
    const result = await createExport({
      ...vars,
      workspaceId,
    })

    return result.export
  }, options)
}
